
<div>
  <nav id="deal-nav" dense
    mat-tab-nav-bar
    [tabPanel]="tabPanel"
    style="width: 100%"
    [ngStyle]="{'background-color': theme.subheader_bg}"
  >
    <!-- Marketing  -->
    <a mat-tab-link
      routerLink="campaigns"
      routerLinkActive="active-link"
      [ngStyle]="{'background-color':theme.subheader_bg, 'color':theme.subheader_fg}"
    >
      Marketing Campaigns
    </a>

    <!-- contacts  -->
    <a mat-tab-link
      routerLink="contacts"
      routerLinkActive="active-link"
      [ngStyle]="{'background-color':theme.subheader_bg, 'color':theme.subheader_fg}"
    >
      Contacts Book
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel style="display: block; width: 100%; height: 100%; padding: 15px;">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>

